module.exports = __webpack_public_path__ + "img/gkmg_apointment.5149c730.svg";